import { render } from "./add-verifikasi.vue?vue&type=template&id=c6cfa0c6"
import script from "./add-verifikasi.vue?vue&type=script&lang=js"
export * from "./add-verifikasi.vue?vue&type=script&lang=js"
script.render = render

export default script